var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoft3Lengeh11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59 30",
    style: {
      enableBackground: "new 0 0 59 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.1,15.2h-6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6c0.3,0,0.5,0.2,0.5,0.5S33.3,15.2,33.1,15.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.5,17.4 27.5,12 24.7,14.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7,15.2h-6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6c0.3,0,0.5,0.2,0.5,0.5S53,15.2,52.7,15.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.1,17.4 47.1,12 44.4,14.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,15.2H6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6c0.3,0,0.5,0.2,0.5,0.5S12.3,15.2,12,15.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.6,12 11.6,17.4 14.3,14.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,30H0V0h59V30z M1,29h57V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.7C19.9,29.8,19.7,30,19.4,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7C39.8,29.8,39.5,30,39.3,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3,24.6H23.7V5.7h11.7V24.6z M24.6,23.6h9.7v-17h-9.7V23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,26.4H39.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h18.7c0.3,0,0.5,0.2,0.5,0.5S58.3,26.4,58.1,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,4.9H39.3c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h18.7c0.3,0,0.5,0.2,0.5,0.5C58.6,4.6,58.3,4.9,58.1,4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8,26.4H0.9c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h17.9c0.3,0,0.5,0.2,0.5,0.5S19.1,26.4,18.8,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8,4.9H0.9c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h17.9c0.3,0,0.5,0.2,0.5,0.5C19.3,4.6,19.1,4.9,18.8,4.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoft3Lengeh11);
export default __webpack_public_path__ + "static/media/joft_3_lengeh_11.5a1b8e583a0861ec55f20e040840d570.svg";
export { ForwardRef as ReactComponent };